import React from 'react';
import MiniDrawer from '../components/Header';
import ProfilePage from '../components/profile';
export default function Profile(props) {
    return (React.createElement(MiniDrawer, { type: "profile" },
        React.createElement(ProfilePage, { token: props.token })));
}
